import { TRANSACTION_COMMON_HEADERS, TRANSACTION_PAYMENT_TYPES } from './TransactionConfig';
import {
  DATE_TIME_COLUMN,
  FILE_COLUMN,
  INVOICE_COLUMN,
  NUMBER_COLUMN,
  PAYMENT_COLUMN,
  PAYMENT_IDENTIFIER,
  TYPE_COLUMN,
} from '../reports/standard/StandardReportConsts';
import { getHeaderTranslationForStandardReports } from '../reports/standard/StandardReportUtils';
import { TransactionsFileCell } from './TransactionsFileCell';
import { TransactionsTypeCell } from './TransactionsTypeCell';
import TransactionsTooltipContent from './TransactionsTooltipContent';
import { formatTimestampAsDateWithTime } from '../../../utils/dates-utils';
import TransactionsPaymentType from './TransactionsPaymentCell';

export const getPaymentProvider = (item, formatMessage) => {
  return TRANSACTION_PAYMENT_TYPES(formatMessage).find(type => type.value === item)?.type || formatMessage({
    id: 'other.payment.type',
    defaultMessage: 'Other',
  });
};

export const getPaymentType = (price, formatMessage) => {
  return price >= 0
    ? formatMessage({ id: 'report.transaction.sale', defaultMessage: 'Sale' })
    : formatMessage({ id: 'report.transaction.return', defaultMessage: 'Return' });
};

export const getPaymentIdentifier = (PaymentTerminalIdentifier) => {
  return PaymentTerminalIdentifier ?? '';
};

export const sortByHeaders = (a, b) => {
  return TRANSACTION_COMMON_HEADERS.indexOf(a) - TRANSACTION_COMMON_HEADERS.indexOf(b);
};

export const isStringDate = (dateStr) => {
  return !isNaN(new Date(dateStr).getDate());
};

export const isInvoice = ({ IsInvoice }) => {
  return IsInvoice;
};

export const convertMachineIdToCashRegister = (MachineId, machinesOptions) => {
  return machinesOptions.find(item => item.value === MachineId)?.label ?? MachineId;
};

export const getPaymentIdentifiers = (report) => {
  const payments = report.Payments || [];
  const identifiers = payments
    .map(item => item.PaymentTerminalIdentifier)
    .filter(identifier => identifier !== null)
    .join(', ');
  
  return identifiers.length > 0 ? identifiers : ' ';
};

export const getNumberOfTotalPages = (pageSize, totalCount) => {
  return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
};

export const getFirstItem = (currentPageId, pageSize) => {
  return (currentPageId * pageSize) + 1;
};

export const isLastPage = (currentPageId, pageSize, transactionsTotal) => {
  const totalPages = getNumberOfTotalPages(pageSize, transactionsTotal);
  return currentPageId + 1 === totalPages;
};

export const getLastItem = (currentPageId, pageSize, transactionsTotal) => {
  return isLastPage(currentPageId, pageSize, transactionsTotal) ? transactionsTotal : (currentPageId + 1) * pageSize;
};

const getExtraHeaders = (type) => {
  const invoiceHeader = type === 1 ? [INVOICE_COLUMN] : (type === 2 ? [NUMBER_COLUMN] : [NUMBER_COLUMN]);
  return [...TRANSACTION_COMMON_HEADERS, ...invoiceHeader];
};

export const getTableHeaders = (initialHeaders, formValues, setDownloadProgress, openItem, setOpenItem, isOpen, formatMessage) => {
  const type = formValues?.values?.transactionType;
  const transactionHeaders = initialHeaders?.filter(item => TRANSACTION_COMMON_HEADERS.includes(item));
  const headers = [...transactionHeaders, ...getExtraHeaders(type)].sort(sortByHeaders);
  
  return headers.map(header => ({
    headerName: getHeaderTranslationForStandardReports(formatMessage, header),
    field: header,
    width: 200,
    outline: 'none',
    align: 'center',
    headerAlign: 'center',
    hide: header === PAYMENT_IDENTIFIER,
    renderCell: (params) => {
      switch (params.field) {
        case FILE_COLUMN:
          return <TransactionsFileCell params={params} setDownloadProgress={setDownloadProgress} />;
        case TYPE_COLUMN:
          return <TransactionsTypeCell type={params.row.Type} />;
        case NUMBER_COLUMN:
        case INVOICE_COLUMN:
          return <TransactionsTooltipContent params={params} formValues={formValues} openItem={openItem}
                                             setOpenItem={setOpenItem} isOpen={isOpen}
                                             setDownloadProgress={setDownloadProgress} />;
        case DATE_TIME_COLUMN:
          return formatTimestampAsDateWithTime(params.value);
        case PAYMENT_COLUMN:
          return <TransactionsPaymentType params={params} formatMessage={formatMessage} />;
        case PAYMENT_IDENTIFIER:
          return getPaymentIdentifiers(params.row, formatMessage);
        default:
          return params.value;
      }
    },
  }));
};